export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: 'e5138ba', dateTime: 1765230760013 };